<template>
  <TableLayout :permissions="['business:orders:query']">
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="订单编号" prop="code">
        <el-input v-model="searchForm.code" clearable placeholder="请输入订单编号" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="物品信息" prop="goodsInfo">
        <el-input v-model="searchForm.goodsInfo" clearable placeholder="请输入物品信息" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="创建时间" prop="createTime1">
        <el-date-picker type="daterange" v-model="searchForm.createTime1" clearable value-format="yyyy-MM-dd"
                        range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" @change="handleDateChange" />
      </el-form-item>
      <el-form-item label="寄件门店" prop="depositShopName">
        <el-input v-model="searchForm.depositShopName" clearable placeholder="请输入寄件门店" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="收件门店" prop="takeShopName">
        <el-input v-model="searchForm.takeShopName" clearable placeholder="请输入收件门店" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-select v-model="searchForm.type" clearable placeholder="请选择类型" @change="search">
          <el-option label="就地存取" :value="0"></el-option>
          <el-option label="同城寄送" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单状态" prop="status">
        <el-select v-model="searchForm.status" clearable placeholder="请选择订单状态" @change="search">
          <el-option label="全部" value=""></el-option>
          <el-option label="待支付" :value="0"></el-option>
          <el-option label="待寄存" :value="1"></el-option>
          <el-option label="已寄存" :value="2"></el-option>
          <el-option label="已接单" :value="3"></el-option>
          <el-option label="派送中" :value="4"></el-option>
          <el-option label="已到店/已送达" :value="5"></el-option>
          <el-option label="已完成" :value="7"></el-option>
          <el-option label="已取消" :value="99"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="结算状态" prop="settlementStatus">
        <el-select v-model="searchForm.settlementStatus" clearable placeholder="请选择结算状态" @change="search">
          <el-option label="待结算" :value="0"></el-option>
          <el-option label="已结算" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
        <el-button :loading="isWorking.export" @click="exportExcel">导出</el-button>
      </section>
    </el-form>
    <template v-slot:table-wrap>
      <el-table
        :height="tableHeightNew"
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
      >
        <el-table-column prop="code" label="订单编号" min-width="160px">
          <template slot-scope="{row}">
            <span class="order-no" @click="handleOrderDetail(row)">{{ row.code }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="goodsInfo" label="物品信息" min-width="120px"></el-table-column>
        <el-table-column label="类型" min-width="80px">
          <template slot-scope="{row}">
            <span v-if="row.type === 0">就地存取</span>
            <span v-else-if="row.type === 1">同城寄送</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="isUrgent" label="订单级别" min-width="80px">
          <template slot-scope="{row}"><span v-if="row.type ===1">{{ row.isUrgent === 1?'极速达':'标速达' }}</span></template>
        </el-table-column>
        <el-table-column label="物品保费（元）" min-width="120px">
          <template slot-scope="{row}">¥{{ (row.declaredFee / 100).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column label="基础服务费（元）" min-width="120px">
          <template slot-scope="{row}">¥{{ (row.price / 100).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column label="订单总价（元）" min-width="120px">
          <template slot-scope="{row}">¥{{ (row.totalAmount / 100).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column label="实付现金（元）" min-width="120px">
          <template slot-scope="{row}">¥{{ (row.payAmount / 100).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column label="加急费（元）" min-width="120px">
          <template slot-scope="{row}"><span v-if="row.type ===1 ">¥{{ (row.urgentAmount / 100).toFixed(2) }}</span></template>
        </el-table-column>
        <el-table-column label="退款金额（元）" min-width="120px">
          <template slot-scope="{row}">¥{{ (row.refundAmount / 100).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column label="超时金额" min-width="100px">
          <template slot-scope="{row}">¥{{ (row.overdueAmount / 100).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column label="异常金额" min-width="100px">
          <template slot-scope="{row}">¥{{ (row.exceptionAmount / 100).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column  prop="statusDesc"  label="订单状态" min-width="100px">
          <template slot-scope="{row}">
            <span :style="{ color: row.status <7 ? '#e6a23c' :  (row.status ===7 ? '#67c23a' : 'grey' )}">
              {{ row.statusDesc }}
            </span>
          </template>
        </el-table-column>
        <el-table-column  label="结算状态" min-width="100px">
          <template slot-scope="{row}">
            <span :style="{ color: row.settlementStatus === 1 ? '#67c23a' : '#e6a23c' }">
              {{ row.settlementStatus === 1 ? '已结算' : '未结算' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="payTime" label="支付时间" min-width="150px"> </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="150px"> </el-table-column>
        <el-table-column label="操作" min-width="120" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" v-if="row.status ===2" @click="handleDispatch(row)">手动派单</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      ></pagination>
    </template>
    <OperaDispatch ref="operaDispatch" @success="handlePageChange" />
    <OperaOrderDetail ref="operaOrderDetail"  @success="handlePageChange"  />
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaDispatch from '@/components/business/OperaDispatch'
import OperaOrderDetail from '@/components/business/OperaOrderDetail'
export default {
  name: 'OrderManagement',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaDispatch, OperaOrderDetail },
  data () {
    return {
      searchForm: {
        code: '',
        goodsInfo: '',
        createTime1: '',
        createStartTime: '',
        createEndTime: '',
        depositShopName: '',
        takeShopName: '',
        type: '',
        status: '',
        settlementStatus: ''
      }
    }
  },
  created () {
    this.config({
      api: '/business/orderManagement',
      'field.id': 'id'
    })
    this.search()
  },
  methods: {
    handleDateChange (val) {
      this.searchForm.createStartTime = val ? val[0] : ''
      this.searchForm.createEndTime = val ? val[1] : ''
      this.search()
    },
    reset () {
      this.searchForm = {
        orderNo: '',
        goodsInfo: '',
        createTime1: '',
        createStartTime: '',
        createEndTime: '',
        sendShopName: '',
        receiveShopName: '',
        type: '',
        orderStatus: '',
        settleStatus: ''
      }
      this.search()
    },
    handleDispatch (row) {
      this.$refs.operaDispatch.open(row)
    },
    handleOrderDetail (row) {
      this.$refs.operaOrderDetail.open(row)
    }
  }
}
</script>
<style scoped>
.order-no {
  color: #2E68EC;
  text-decoration: underline;
  cursor: pointer;
}
</style>
